const isPreviewableVideo = (file: File) => !!file.type?.startsWith('video');

export { isPreviewableVideo };
